import { OptionProps } from "react-select";
import "./TwoRowSelectOption.scss";

export const TwoRowSelectOption = ({
  innerProps,
  data,
}: OptionProps<any, any>) => {
  return (
    <div className="two-row-select-option" {...innerProps}>
      <div className="title">{data.name}</div>
      <div className="description">{data.description}</div>
    </div>
  );
};
